import { TextFieldComponent } from './../text-field/text-field.component';
import {
  Component,
  Injector,
  Input,
  ViewChild,
  OnChanges,
  SimpleChanges,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import { AbstractValueAccessor, MakeProvider } from '../abstract-value-accessor';
import { BehaviorSubject } from 'rxjs';
import { delayedPromise } from '@anecdotes/utils';

@Component({
  selector: 'app-copy-text-field',
  templateUrl: './copy-text-field.component.html',
  styleUrls: ['./copy-text-field.component.scss'],
  providers: [MakeProvider(CopyTextFieldComponent)],
  standalone: false,
})
export class CopyTextFieldComponent extends AbstractValueAccessor implements OnChanges, AfterViewInit {
  @ViewChild('textField')
  private textFieldComponent: TextFieldComponent;

  runCopyAnimation$ = new BehaviorSubject<boolean>(false);

  @Input()
  errorTexts: { [key: string]: string | (() => string) };

  @Input()
  required: boolean;

  @Input()
  index: number;

  @Input()
  validateOnDirty: boolean;

  @Input()
  readonly: boolean;

  @Input()
  label: string;

  @Input()
  valueToPass: string;

  @Input()
  showHideText = false;

  @Input()
  inputType: 'text' | 'password' = 'text';

  get inputTypeModified(): string {
    if (this.readonly && this.inputType === 'password') {
      return 'text';
    }

    return this.inputType;
  }

  get inputTextModified(): string {
    if (this.isReadonlyPassword()) {
      return this.mask(this.valueToPass, 2, 3);
    }

    return this.valueToPass;
  }

  constructor(injector: Injector, private cd: ChangeDetectorRef) {
    super(injector);
  }

  ngAfterViewInit(): void {
    this.setValue(this.inputTextModified);
    this.cd.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);

    if ('valueToPass' in changes && this.textFieldComponent) {
      this.setValue(this.inputTextModified);
      if (this.showHideText && this.textFieldComponent.textfieldElement.nativeElement.type === 'text') {
        this.textFieldComponent.toggleShowHide();
      }
    }
  }

  inputValue(inputValue: string): void {
    this.setValue(inputValue);
  }

  private setValue(value: string): void {
    this.value = value;
    this.textFieldComponent.value = value;
  }

  async copyText(): Promise<void> {
    navigator.clipboard.writeText(this.valueToPass);
    this.runCopyAnimation$.next(true);
    await delayedPromise(2000);
    this.runCopyAnimation$.next(false);
  }

  buildTranslationKey(partital: string): string {
    return `core.formControls.copyTextField.${partital}`;
  }

  private mask(str: string, start: number, end: number): string {
    return Array.from(str)
      .map((char, index) => index >= start && index < str.length - end ? '*' : char)
      .join('');
  }

  private isReadonlyPassword(): boolean {
    return this.inputType === 'password' && this.readonly;
  }
}
